import { render, staticRenderFns } from "./SelectPractitioner.vue?vue&type=template&id=1478d2f0&"
import script from "./SelectPractitioner.vue?vue&type=script&lang=js&"
export * from "./SelectPractitioner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports